import { OnboardingStatus, User, UserType } from "../API";
import { PATHS } from "../navigation/paths";

export const getOnboardingPath = (user: User) => {
  const { userType, id, onboardingStatus } = user;

  if (userType === UserType.Buyers) {
    switch (onboardingStatus) {
      case OnboardingStatus.PROFILE:
        return PATHS.onboardingUser;

      case OnboardingStatus.INTERESTS:
        return `${PATHS.onboardingInterests}?category=${user.country}`;

      case OnboardingStatus.LOCATIONS:
        return `${PATHS.onboardingLocations}?category=${user.country}`;

      case OnboardingStatus.PLANS:
        return PATHS.onboardingPlans;

      case OnboardingStatus.COMPLETED:
        return PATHS.swipes;

      default:
        return PATHS.swipes;
    }
  }

  if (userType === UserType.Sellers) {
    switch (onboardingStatus) {
      case OnboardingStatus.PROFILE:
        return PATHS.onboardingUser;

      case OnboardingStatus.PLANS:
        return PATHS.onboardingPlans;

      case OnboardingStatus.COMPLETED:
        return `${PATHS.products}?userId=${id}`;

      default:
        return `${PATHS.products}?userId=${id}`;
    }
  }

  return PATHS.dashboard;
};
